import { memo } from 'react';
import { useTerminalStore } from '../../stores/terminal.store.js';
import { formatPriceWithSymbol, formatChange } from '@arc/shared';
import { DEFAULT_TOKENS } from '@arc/shared';

export const NewsTicker = memo(function NewsTicker() {
  const prices = useTerminalStore(s => s.prices);

  const items = DEFAULT_TOKENS.map(token => {
    const p = prices[token.symbol];
    return {
      symbol:   token.symbol,
      price:    p?.priceUsd ?? 0,
      change:   p?.change24h ?? 0,
    };
  });

  // Double for seamless loop
  const tickerItems = [...items, ...items];

  return (
    <div className="flex-shrink-0 h-6 bg-[#020a14] border-t border-hud overflow-hidden flex items-center">
      {/* Label */}
      <div className="font-mono text-[11px] text-arc tracking-[3px] font-bold px-3 border-r border-hud flex-shrink-0 h-full flex items-center">
        SIGNAL
      </div>

      {/* Scrolling prices */}
      <div className="flex-1 overflow-hidden">
        <div
          className="flex whitespace-nowrap"
          style={{ animation: 'tickerScroll 40s linear infinite' }}
        >
          {tickerItems.map((item, i) => (
            <span
              key={i}
              className="font-mono text-[11px] px-5 border-r border-hud h-6 flex items-center gap-1.5 flex-shrink-0"
            >
              <span className="text-muted">{item.symbol}/USDT</span>
              {item.price > 0 ? (
                <span className="text-bright">{formatPriceWithSymbol(item.price)}</span>
              ) : (
                <span className="text-muted italic" title={`No price data for ${item.symbol} yet`}>no data</span>
              )}
              <span className={item.price <= 0 || item.change === 0 ? 'text-muted' : item.change > 0 ? 'text-buy' : 'text-sell'}>
                {item.change !== 0 ? formatChange(item.change) : ''}
              </span>
            </span>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes tickerScroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
});
